module.exports = __webpack_public_path__ + "static/media/51.fa69d675.png";